/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/* eslint-disable import/no-unresolved, import/default */

import logoSvg from '../../svg/agrolog_logo.svg'; // eslint-disable-line
import tornumLogoSvg from '../../svg/tornum-logo.svg'; // eslint-disable-line
import mySiloLogoPng from '../../png/mysilo_logo.png';
import pradoSilosLogoPng from '../../png/pradosilos_logo.png';
import chiefLogoPng from '../../png/chief-logo.png';
import cimbriaLogoPng from '../../png/cimbria_logo.png';
import agiLogoSvg from '../../png/agi_logo.svg';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function LoginController(toast, $window, agTypes, loginService, userService, types, $state, $stateParams, $mdDialog, $translate, jwtHelper, customerService) {
    var vm = this;
    vm.agTypes = agTypes;

    vm.countries = [];
    vm.licenseUrl = '';
    vm.forceCountrySelection = false;
    vm.selectedBillingCountry = null;
    vm.businessCustomer = true;
    vm.companyName = '';
    vm.vatNumber = '';
    vm.activationPending = false;
    vm.tempToken = null;
    vm.currentHostname = $window.location.hostname;
    vm.submitBillingDetails = submitBillingDetails;
    vm.openChargebeePortal = openChargebeePortal;

    if (vm.currentHostname === agTypes.customerHostanmes.tornum) {
        vm.logoSvg = tornumLogoSvg;
    } else if (vm.currentHostname === agTypes.customerHostanmes.chief) {
        vm.logoSvg = chiefLogoPng;
    } else if (vm.currentHostname === agTypes.customerHostanmes.cimbria) {
        vm.logoSvg = cimbriaLogoPng;
    } else if (vm.currentHostname === agTypes.customerHostanmes.agi) {
        vm.logoSvg = agiLogoSvg;
    } else if (vm.currentHostname === agTypes.customerHostanmes.mysilo) {
        vm.logoSvg = mySiloLogoPng;
    } else if (vm.currentHostname === agTypes.customerHostanmes.pradosilos) {
        vm.logoSvg = pradoSilosLogoPng;
    } else {
        vm.logoSvg = logoSvg;
    }

    vm.user = {
        name: '',
        password: ''
    };

    vm.signUp = signUp;
    vm.login = login;

    if ($stateParams.username && $stateParams.password) {
        vm.user.name = $stateParams.username;
        vm.user.password = $stateParams.password;
        doLogin();
    }

    function openChargebeePortal() {
        $window.open(vm.licenseUrl);
    }

    function doLogin() {
        loginService.login(vm.user).then(function success(response) {
            let nullUUID = "13814000-1dd2-11b2-8080-808080808080";
            let token = response.data.token;
            let refreshToken = response.data.refreshToken;
            let customerId = jwtHelper.decodeToken(token).customerId;
            if(customerId !== nullUUID) {
                let config = {
                    headers: {
                        'X-Authorization': 'Bearer ' + token
                    },
                    ignoreErrors: true
                }
                customerService.getCustomerLogin(customerId, config).then(() => {
                    userService.setUserFromJwtToken(token, refreshToken, true);
                    vm.licenseUrl = '';
                    vm.forceCountrySelection = false;
                    resetSubscriptionCheckout();
                    vm.tempToken = null;

                }, (response) => {
                    if (response && response.errorCode) {
                        vm.licenseUrl = '';
                        vm.forceCountrySelection = false;
                        resetSubscriptionCheckout();
                        vm.tempToken = token;

                        if (token?.length > 1) {
                            userService.loadLicenseStatusPublic(token).then(licenseStatus => {
                                vm.licenseUrl = licenseStatus?.url;
                                vm.forceCountrySelection = licenseStatus?.forceCountrySelection ?? false;
                                resetSubscriptionCheckout();

                                if (vm.forceCountrySelection) {
                                    userService.fetchCountries().then(response => {
                                        vm.countries = response?.data ?? [];
                                    });
                                }
                            });
                        }
                    }
                })
            } else {
                userService.setUserFromJwtToken(token, refreshToken, true);
            }
        }, function fail(response) {
            /*if (response && response.data && response.data.message) {
                toast.showError(response.data.message);
            } else if (response && response.statusText) {
                toast.showError(response.statusText);
            } else {
                toast.showError($translate.instant('error.unknown-error'));
            }*/
            if (response && response.data && response.data.errorCode) {
                if (response.data.errorCode === types.serverErrorCode.credentialsExpired) {
                    $state.go('login.resetExpiredPassword', {resetToken: response.data.resetToken});
                }
            }
        });
    }

    function signUp() {
        $state.go('signup');
    }

    function login() {
        doLogin();
    }

    function submitBillingDetails(billingDetailsForm) {
        if (billingDetailsForm.$invalid) {
            billingDetailsForm.$setSubmitted();
            return;
        }
        createSubscriptionCheckout();
    }

    function createSubscriptionCheckout() {
        const checkoutRequest = {
            country: vm.selectedBillingCountry,
            businessCustomer: vm.businessCustomer
        };

        if (vm.businessCustomer) {
            checkoutRequest.companyName = vm.companyName;
            checkoutRequest.vatNumber = vm.vatNumber;
        }

        vm.activationPending = true;
        userService.createSubscriptionCheckoutPublic(vm.tempToken, checkoutRequest).then(licenseStatus => {
            if (licenseStatus?.url) {
                $window.location.href = licenseStatus.url;
            }
        }).finally(() => {
            vm.activationPending = false;
        });
    }

    function resetSubscriptionCheckout() {
        vm.selectedBillingCountry = null;
        vm.businessCustomer = true;
        vm.companyName = '';
        vm.vatNumber = '';
        vm.activationPending = false;
    }
}
